/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Display_Aria_LabelInputs */

const en_styles_display_aria_label = /** @type {(inputs: Styles_Display_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display Profile`)
};

const fr_styles_display_aria_label = /** @type {(inputs: Styles_Display_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil d'affichage`)
};

const de_styles_display_aria_label = /** @type {(inputs: Styles_Display_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeigeprofil`)
};

const it_styles_display_aria_label = /** @type {(inputs: Styles_Display_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza profilo`)
};

const ru_styles_display_aria_label = /** @type {(inputs: Styles_Display_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отображение профиля`)
};

const es_styles_display_aria_label = /** @type {(inputs: Styles_Display_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil de visualización`)
};

const zh_cn2_styles_display_aria_label = /** @type {(inputs: Styles_Display_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示配置文件`)
};

const ja_styles_display_aria_label = /** @type {(inputs: Styles_Display_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ディスプレイプロフィール`)
};

const hi_styles_display_aria_label = /** @type {(inputs: Styles_Display_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोफ़ाइल प्रदर्शित करें`)
};

const pt_pt2_styles_display_aria_label = /** @type {(inputs: Styles_Display_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exibir perfil`)
};

/**
* | output |
* | --- |
* | "Display Profile" |
*
* @param {Styles_Display_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_display_aria_label = /** @type {((inputs?: Styles_Display_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Display_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_display_aria_label(inputs)
	if (locale === "de") return de_styles_display_aria_label(inputs)
	if (locale === "it") return it_styles_display_aria_label(inputs)
	if (locale === "ru") return ru_styles_display_aria_label(inputs)
	if (locale === "es") return es_styles_display_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_display_aria_label(inputs)
	if (locale === "ja") return ja_styles_display_aria_label(inputs)
	if (locale === "hi") return hi_styles_display_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_display_aria_label(inputs)
	return en_styles_display_aria_label(inputs)
});